import { createTheme, type Theme } from '@mui/material/styles';
import { ptBR } from '@mui/material/locale';
import { criarPalette } from './palette';
import typography from './typography';
import componentes from './components';

export type ModoTema = 'light' | 'dark';

function estiloScrollbar(mode: ModoTema) {
  const cores = {
    track: mode === 'dark' ? 'rgba(65, 75, 82, 0.3)' : '#F5F5F5',
    active: mode === 'dark' ? 'rgba(79, 91, 100)' : 'rgba(191, 191, 191, 0.4)',
    thumb: mode === 'dark' ? 'rgba(79, 91, 100, 0.6)' : 'rgba(191, 191, 191, 0.6)',
  };
  return {
    '@supports not selector(::-webkit-scrollbar)': {
      scrollbarColor: `${cores.thumb} ${cores.track}`,
      scrollbarWidth: 'thin',
    },
    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
      backgroundColor: cores.track,
    },
    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
      minHeight: 10,
      border: `1px solid ${cores.track}`,
      borderRadius: '5px',
      backgroundColor: cores.thumb,
    },
    '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': { backgroundColor: cores.active },
    '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': { backgroundColor: cores.active },
    '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': { backgroundColor: cores.active },
    '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': { backgroundColor: cores.track },
  };
}

/**
 * Cria o tema MUI com modo light/dark.
 * Espelha `sischef-app/src/theme/index.js` — paleta, tipografia e
 * overrides idênticos pra manter consistência visual com o Sischef.
 */
export function criarTemaApp(mode: ModoTema): Theme {
  return createTheme(
    {
      palette: criarPalette(mode),
      typography,
      components: {
        ...componentes,
        MuiCssBaseline: {
          styleOverrides: { body: estiloScrollbar(mode) },
        },
      },
      zIndex: { appBar: 1200 },
    },
    ptBR,
  );
}
